import { useEffect, useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";
import api from "@/api";
import { isMuted, setMuted } from "@/utils/sound";

export default function MusicPlayer() {
  const [config, setConfig] = useState(null);
  const [muted, setMutedState] = useState(isMuted());
  const [started, setStarted] = useState(false);
  const [trackIdx, setTrackIdx] = useState(0);
  const audioRef = useRef(null);

  useEffect(() => {
    api.get("/music").then((r) => setConfig(r.data)).catch(() => setConfig({ enabled: false, tracks: [] }));
  }, []);

  useEffect(() => {
    const onSound = (e) => {
      setMutedState(e.detail);
      const audio = audioRef.current;
      if (!audio) return;
      audio.muted = e.detail;
      if (e.detail) audio.pause();
      else if (started) audio.play().catch(() => {});
    };
    window.addEventListener("cetf:sound", onSound);
    return () => window.removeEventListener("cetf:sound", onSound);
  }, [started]);

  useEffect(() => {
    const audio = audioRef.current;
    if (audio && started && !muted) audio.play().catch(() => {});
  }, [trackIdx, started]);

  if (!config || !config.enabled || !config.tracks || config.tracks.length === 0) return null;

  const tracks = config.tracks;
  const current = tracks[trackIdx % tracks.length];
  const src = `${process.env.REACT_APP_BACKEND_URL}/api/music-files/${current.storage_path}`;

  const toggle = () => {
    const next = !muted;
    setMuted(next);
    if (!next) {
      setStarted(true);
      const audio = audioRef.current;
      if (audio) {
        audio.muted = false;
        audio.play().catch(() => {});
      }
    }
  };

  return (
    <>
      <audio
        ref={audioRef}
        src={src}
        muted={muted}
        onEnded={() => setTrackIdx((i) => (i + 1) % tracks.length)}
        data-testid="music-audio"
      />
      <button
        type="button"
        onClick={toggle}
        aria-label={muted ? "Activer la musique" : "Couper la musique"}
        data-testid="music-toggle-btn"
        className="fixed left-4 bottom-20 z-40 h-11 w-11 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white shadow-lg flex items-center justify-center transition-colors"
      >
        {muted ? <VolumeX className="h-5 w-5" /> : <Volume2 className="h-5 w-5" />}
      </button>
    </>
  );
}
